const subscriptionSubmissionTypes = {
  NO_PAYMENT: 'NO_PAYMENT',
  CARD_PAYMENT: 'CARD_PAYMENT',
  APPLE_PAY: 'APPLE_PAY',
};

export default subscriptionSubmissionTypes;
